var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"py-10 py-sm-16",attrs:{"id":"solution"}},[_c('v-container',[_c('v-row',{staticClass:"mb-10 text-center",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10"}},[_c('h2',{class:[
            'font-weight-bold',
            _vm.$vuetify.breakpoint.mdAndUp ? 'text-h2' : 'text-h4',
          ]},[_vm._v(" "+_vm._s(_vm.$t("section_2_title"))+" ")])])],1),_vm._l((_vm.modules),function(module,i){return _c('moduleItem',{key:i,attrs:{"icon":module.icon,"title":module.title,"text":module.text}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }